///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnInit } from '@angular/core';
import { AccountService } from '../../shared/auth/account.service';
import { Principal } from '../../shared/auth/principal.service';
import { UserDTO } from '../../generated/shared-types.model';
import { SuiUserDTO } from '../../generated/shared-sui-types.model';
import { SuiTranslateService } from '@siklu/sui-lib/localization';

@Component({
    selector: 'winde-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
    public success: string;
    public settingsAccount: SuiUserDTO;

    constructor(
        private readonly account: AccountService,
        private readonly principal: Principal,
        private readonly translateService: SuiTranslateService
    ) {}

    ngOnInit() {
        this.principal.identity(true).then((account: UserDTO) => {
            this.settingsAccount = new SuiUserDTO(account);
            this.prepareControls();
        });
    }

    prepareControls(): void {
        this.settingsAccount.firstName.isMandatory = true;
        this.settingsAccount.firstName.placeholder = this.translateService.translate('settings.form.firstname.placeholder');

        this.settingsAccount.lastName.isMandatory = true;
        this.settingsAccount.lastName.placeholder = this.translateService.translate('settings.form.lastname.placeholder');
    }

    save() {
        if (this.areControlsValid()) {
            this.account.save(this.settingsAccount.toDto()).subscribe({
                next: () => {
                    this.success = 'OK';
                    this.principal.identity(true).then((account: UserDTO) => {
                        this.settingsAccount.firstName.setValue(account.firstName);
                        this.settingsAccount.lastName.setValue(account.lastName);
                    });
                },
                error: () => {
                    this.success = null;
                }
            });
        }
    }

    private areControlsValid(): boolean {
        return [this.settingsAccount.firstName.validateAndShowError(), this.settingsAccount.lastName.validateAndShowError()].every(
            (status: boolean) => status
        );
    }
}
